/**
 * Shared "has this visitor already subscribed?" state, unifying the
 * localStorage keys written independently by the footer EmailSignupForm, the
 * retired reveal-a-code SavingsPopup (its legacy llc_savings_* keys still
 * count), and the retired "Before you go" modal (legacy
 * llc_email_capture_state key). Reading all keys means a signup from any
 * surface — past or present — suppresses every email-capture prompt going
 * forward. Guests save ~15% vs. Airbnb/VRBO by skipping platform guest fees.
 */

const EMAIL_CAPTURE_KEY = "llc_email_capture_state";
const SAVINGS_SUBSCRIBED_KEY = "llc_savings_subscribed";
const SAVINGS_CODE_KEY = "llc_savings_code";

export function hasSubscribed(): boolean {
  try {
    if (localStorage.getItem(SAVINGS_SUBSCRIBED_KEY) === "1") return true;
    if (localStorage.getItem(SAVINGS_CODE_KEY)) return true;
    const raw = localStorage.getItem(EMAIL_CAPTURE_KEY);
    if (raw) {
      const state = JSON.parse(raw) as { signedUp?: boolean };
      if (state?.signedUp) return true;
    }
  } catch {
    /* no-op */
  }
  return false;
}

/**
 * Mark the visitor as subscribed across every popup's state so all
 * email-capture surfaces suppress themselves consistently. The optional code
 * param remains for legacy callers but new surfaces no longer mint codes.
 */
export function markSubscribed(code?: string) {
  try {
    localStorage.setItem(SAVINGS_SUBSCRIBED_KEY, "1");
    if (code) localStorage.setItem(SAVINGS_CODE_KEY, code);
  } catch {
    /* no-op */
  }
  try {
    const raw = localStorage.getItem(EMAIL_CAPTURE_KEY);
    const prev = raw ? (JSON.parse(raw) as Record<string, unknown>) : {};
    localStorage.setItem(EMAIL_CAPTURE_KEY, JSON.stringify({ ...prev, signedUp: true }));
  } catch {
    /* no-op */
  }
}
